import { render, staticRenderFns } from "./new_report_whole.vue?vue&type=template&id=66ff9484&scoped=true&"
import script from "./new_report_whole.vue?vue&type=script&lang=js&"
export * from "./new_report_whole.vue?vue&type=script&lang=js&"
import style1 from "./new_report_whole.vue?vue&type=style&index=1&id=66ff9484&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff9484",
  null
  
)

export default component.exports